import React, { useEffect } from 'react'
import { toast, ToastContainer } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";

const ResponceToaster = ({ toasterType, message, onClick }) => {

    const toastIdRef = React.useRef(null);

    useEffect(() => {

        if (toasterType === 'success') {
            toastIdRef.current = toast.success(message, {
                position: "top-center",
                autoClose: 3000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                className: 'fs-5 font-w600 text-white',
                style: {
                    backgroundColor: 'rgba(79, 93, 116, 1)',
                    padding: '10px',
                },
                closeButton: <div className='text-white'>X</div>

                // position: "bottom-left",
                // autoClose: 10000,
                // hideProgressBar: false,
                // closeOnClick: true,
                // pauseOnHover: true,
                // draggable: true,
                // progress: undefined,
            });
        }

        else if (toasterType === 'error') {
            toastIdRef.current = toast.error(message, {
                position: "top-center",
                autoClose: 11000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                className: 'fs-5 font-w600 text-white',
                style: {
                    backgroundColor: 'rgba(79, 93, 116, 1)',
                    padding: '10px',
                },
                closeButton: <div className='text-white'>X</div>


                // position: "bottom-left",
                // autoClose: 10000,
                // hideProgressBar: false,
                // closeOnClick: true,
                // pauseOnHover: true,
                // draggable: true,
                // progress: undefined,
            });
        }
        else if (toasterType === 'warning') {
            toastIdRef.current = toast.warn(message, {
                position: "top-center",
                autoClose: 11000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                className: 'fs-5 font-w600 text-white',
                style: {
                    backgroundColor: 'rgba(79, 93, 116, 1)',
                    padding: '10px',
                },
                closeButton: <div className='text-white'>X</div>

                // position: "bottom-left",
                // autoClose: 10000,
                // hideProgressBar: false,
                // closeOnClick: true,
                // pauseOnHover: true,
                // draggable: true,
                // progress: undefined,
            });
        }
        else if (toasterType === 'info') {
            toastIdRef.current = toast.info(message, {
                position: "top-center",
                autoClose: 11000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                className: 'fs-5 font-w600 text-white',
                style: {
                    backgroundColor: 'rgba(79, 93, 116, 1)',
                    padding: '10px',
                },
                closeButton: <div className='text-white'>X</div>

                // position: "bottom-left",
                // autoClose: 10000,
                // hideProgressBar: false,
                // closeOnClick: true,
                // pauseOnHover: true,
                // draggable: true,
                // progress: undefined,
                // onClick: onClick
            });
        }
    }, [toasterType, message])


    return (
        <div>
            <ToastContainer />

        </div>
    )
}

export default ResponceToaster;


